<div class="row" [ngClass]="{ inFilter: filterRecipients!=undefined }">
  <!-- //[style.height]="'8vh'" -->
  <div class="warp-answer">
    <div class="warp-contact" *ngIf="filterRecipients==undefined">
      <que-contact-circle [displayTooltip]="true" [user]="answerByRecipient?.recipient?.user">
      </que-contact-circle>
    </div>
    <div
      [ngClass]="{answerWasChange: showComparison$() && answerByRecipient?.wasChange,inFilter: filterRecipients!=undefined}"
      class="answer" *ngIf="!isSource; else soureAnswer">
      <span *ngIf="question?.type?.id !=  eQuestionType.Signature "> {{ answerByRecipient?.answer | answerSwitchType :
        question }}</span>
      <div *ngIf="question?.type?.id ==  eQuestionType.Signature " class="sign-warp">
        <img *ngIf="answerByRecipient?.answer?.base64" [src]="answerByRecipient?.answer?.base64">
        <div *ngIf="question?.isIncludeDate && answerByRecipient?.answer?.dateAnswerNTZ" class="date"><span translate>questionBoard.edit.signatureDate</span>: {{answerByRecipient?.answer?.dateAnswerNTZ | queDate}}</div>
      </div>
    </div>
  </div>
</div>


<ng-template #soureAnswer>
  <div class="answer " [ngClass]="{inFilter: filterRecipients!=undefined}">
    <div *ngIf="question?.type?.id !=  eQuestionType.Signature "> {{ answerByRecipient?.answerSource | answerSwitchType
      : question }}</div>
    <div *ngIf="question?.type?.id ==  eQuestionType.Signature "  class="sign-warp">
      <img *ngIf="answerByRecipient?.answerSource?.base64"  [src]="answerByRecipient?.answerSource?.base64">
     <div *ngIf="question?.isIncludeDate && answerByRecipient?.answerSource?.dateAnswerNTZ" class="date"><span translate>questionBoard.edit.signatureDate</span>: {{answerByRecipient?.answerSource?.dateAnswerNTZ | queDate}}</div>
     
    </div>
  </div>

</ng-template>